module.exports = __webpack_public_path__ + "static/img/luoyangzg.15b1767d.png";